// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"LoaderSlide_loaderWrapper__qRIw7","loaderText":"LoaderSlide_loaderText__UuJti"};